import { useContext, useMemo } from "react";
import { ConfigContext } from "../../context/config";
function useConfig(path, optional = true) {
    const config = useContext(ConfigContext);
    return useMemo(() => {
        if (!path)
            return config;
        return path
            .split(".")
            .reduce((innerConfig, key) => {
            const value = innerConfig?.[key];
            if (value === undefined && !optional)
                throw new Error(`Missing non-optional config: \`${key}\` not found (\`${path}\`)`);
            return value;
        }, config);
    }, [path, optional, config]);
}
export { useConfig };
